<template>
  <div class="d-flex align-center">
    <div class="body2 ml-2 mr-2 text-indigo-medium">
      {{ $t("general.poweredBy") }}
    </div>
    <img src="/images/app-service-logos/icon-app-keepit.png" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>
